export default __webpack_public_path__ + "static/media/background.d69ab65b.png";